var render = function render(){var _vm=this,_c=_vm._self._c;return _c('uiTf',_vm._b({attrs:{"ct":_vm.ct,"label":_vm.label,"styleComp":_vm.styleComp,"required":_vm.required,"type":_vm.showPass? 'text' : 'password',"append-icon":_vm.showPass ? 'mdi-eye' : 'mdi-eye-off'},on:{"onAppend":function($event){_vm.showPass = !_vm.showPass}}},'uiTf',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }